import { baseBackend } from "../../../../../api/base/baseUrl";

export async function getDriverCategoriesRequest() {
  return baseBackend.get("/api/v2/driver-category");
}
